import { useMemo, useRef } from 'react';
import { ReactComponent as InfoOutlined } from '../../../../assets/icons/information-line.svg';
import { OverflowTooltip } from '../../../../shared/components/tooltip/OverflowTooltip';
import { NbTooltip } from '../../../../shared/components/tooltip/Tooltip';
import { cssWhen } from '../../../../shared/utils/themeUtils';
import classes from './ProductDetailsListRow.module.scss';

interface ProductDetailsListRowProps {
  label: string;
  value: string | number;
  info?: string;
  isNumber?: boolean;
  shouldNotCapValueLength?: boolean;
}

export const ProductDetailsListRow = ({
  label,
  value,
  isNumber,
  info,
  shouldNotCapValueLength,
}: ProductDetailsListRowProps) => {
  const valueSpan = useMemo(
    () => (
      <span
        className={cssWhen(
          classes.rowValue,
          [shouldNotCapValueLength !== true, classes.rowValueCappedMaxLength],
          [isNumber, classes.rowValueIsNumber],
        )}
      >
        {value}
      </span>
    ),
    [isNumber, value, shouldNotCapValueLength],
  );
  const containerRef = useRef<HTMLDivElement | null>(null);

  return (
    <div
      ref={containerRef}
      className={classes.row}
    >
      <span className={classes.rowLabel}>
        {label}
        {info && (
          <NbTooltip
            title={info}
            placement="top"
          >
            <InfoOutlined />
          </NbTooltip>
        )}
      </span>

      <OverflowTooltip
        parentContainerRef={containerRef}
        title={value.toString()}
        children={valueSpan}
      />
    </div>
  );
};
